function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useState } from 'react';
import { CONFIRM_MAP, CONFIRM_SETTING, INTERACTION_LIST, INTERACTION_TITLE_LIST } from "../../utils/constants";
import { Button, Select } from 'antd';
import style from "./style.module.less";
import { getSchema } from "../../utils";
import { useSettingInteractionList } from "../../hooks/useSettingInteractionList";
import { CloseOutlined } from '@ant-design/icons';
var InteractionSettingRow = function InteractionSettingRow(props) {
  var item = props.item,
    onSelectChange = props.onSelectChange,
    delInteraction = props.delInteraction,
    index = props.index;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    valueList = _useState2[0],
    setValueList = _useState2[1];
  var getOptions = function getOptions(type) {
    var valueList = [];
    switch (type) {
      // 锚点
      case INTERACTION_TITLE_LIST[0]:
        valueList = getSchema('all');
        break;
      case INTERACTION_TITLE_LIST[1]:
        valueList = getSchema('modal');
        break;
      default:
        valueList = CONFIRM_SETTING;
        break;
    }
    setValueList(valueList);
  };
  var defaultValue = (item === null || item === void 0 ? void 0 : item.title) === 'confirm' ? CONFIRM_MAP[item === null || item === void 0 ? void 0 : item.value] : item === null || item === void 0 ? void 0 : item.value;
  return /*#__PURE__*/React.createElement("div", {
    className: style.interactionSetting
  }, /*#__PURE__*/React.createElement(Select, {
    size: "small",
    defaultValue: item === null || item === void 0 ? void 0 : item.title,
    className: style.leftSelect,
    onChange: function onChange(val) {
      return onSelectChange(val, 'key');
    },
    options: INTERACTION_LIST
  }), /*#__PURE__*/React.createElement(Select, {
    size: "small",
    className: style.rightSelect,
    onDropdownVisibleChange: function onDropdownVisibleChange() {
      return getOptions(item === null || item === void 0 ? void 0 : item.title);
    },
    options: valueList,
    defaultValue: defaultValue || null,
    placeholder: "\u8BF7\u9009\u62E9"
    // ts-ignore
    ,

    onChange: function onChange(val) {
      return onSelectChange(val, 'value');
    }
  }), /*#__PURE__*/React.createElement(CloseOutlined, {
    className: style.closeIcon,
    onClick: function onClick() {
      return delInteraction(item.key, index);
    }
  }));
};
export var InteractionSetting = function InteractionSetting(props) {
  var onSettingChange = props.onSettingChange,
    addInteraction = props.addInteraction,
    interactionList = props.interactionList,
    delInteraction = props.delInteraction;
  return /*#__PURE__*/React.createElement("div", null, interactionList === null || interactionList === void 0 ? void 0 : interactionList.map(function (item, index) {
    return /*#__PURE__*/React.createElement(InteractionSettingRow
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: "".concat(item.title).concat(index),
      onSelectChange: function onSelectChange(val, type) {
        return onSettingChange(val, index, type);
      },
      item: item,
      delInteraction: delInteraction,
      index: index
    });
  }), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    type: "primary",
    onClick: addInteraction,
    style: {
      marginBottom: '12px'
    }
  }, "\u6DFB\u52A0\u4EA4\u4E92"));
};
InteractionSetting.useSetting = useSettingInteractionList;